import { Box, type BoxProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function Card({
  children,
  px = '24px',
  py = '24px',
  clickable = false,
  hideBorder = false,
  withBoxShadow = false,
  ...props
}: {
  children: ReactNode
  clickable?: boolean
  hideBorder?: boolean
  withBoxShadow?: boolean
} & BoxProps): JSX.Element {
  return (
    <Box
      px={px}
      py={py}
      bg="bg"
      border={hideBorder ? 'none' : '2px solid'}
      borderColor="border.muted"
      borderRadius="8px"
      cursor={clickable ? 'pointer' : 'default'}
      boxShadow={
        withBoxShadow ? `0px 4px 4px 0px ${chakraTokenToVar('gray.emphasized')}` : undefined
      }
      _hover={
        clickable
          ? {
              borderColor: 'border.emphasized',
              boxShadow: withBoxShadow
                ? `0px 8px 8px 0px ${chakraTokenToVar('gray.emphasized')}`
                : undefined,
            }
          : undefined
      }
      _active={clickable ? { borderColor: 'primary.solid' } : undefined}
      {...props}
    >
      {children}
    </Box>
  )
}
